/**
 * Utility functions for the targeted support overview feature.
 */
import {
  Outcome,
  Representation,
} from "@financial-advisory/data-access/api-types";
import type { ProductTree } from "@financial-advisory/data-access/api-types";
import { LogicalOperator } from "@financial-advisory/data-access/api-types";
import type { OverviewItem, Tab, TabType } from "./types";

/**
 * Creates a tab configuration from an overview item (outcome or guardrail).
 * This function generates the tab metadata including icon styling based on the item type.
 *
 * @param item - The overview item (outcome or guardrail) to create a tab from
 * @returns A tab configuration object with id, label, type, and icon styling
 */
export const createTabFromItem = (item: OverviewItem): Tab => ({
  id: `${item.type}-${item.id}`,
  label: item.title,
  type: item.type as TabType,
  relatedId: item.id,
  icon: {
    variant: item.type === "outcome" ? "circle" : "diamond",
    label: "S",
    background: "#0F172A",
    foreground: "#0F172A",
  },
});
